import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { DialogAddNotificationComponent } from './components/dialog-add-notification/dialog-add-notification.component';
import { DialogAddTaskRuleComponent } from './components/dialog-add-task-rule/dialog-add-task-rule.component';
import { TaskRuleTimingComponent } from './components/task-rule-timing/task-rule-timing.component';
import { OperationsRoutingModule } from './operations-routing.module';
import { LogDetailComponent } from './pages/log-detail/log-detail.component';
import { LogsComponent } from './pages/logs/logs.component';
import { NotificationDetailComponent } from './pages/notification-detail/notification-detail.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { OpsOverviewComponent } from './pages/ops-overview/ops-overview.component';
import { TaskAutomationComponent } from './pages/task-automation/task-automation.component';
import { TaskDetailComponent } from './pages/task-detail/task-detail.component';
import { TeamDetailComponent } from './pages/team-detail/team-detail.component';
import { TeamComponent } from './pages/team/team.component';

@NgModule({
  declarations: [
    TaskAutomationComponent,
    TeamComponent,
    NotificationsComponent,
    TaskDetailComponent,
    TeamDetailComponent,
    LogsComponent,
    OpsOverviewComponent,
    LogDetailComponent,
    NotificationDetailComponent,
    DialogAddNotificationComponent,
    DialogAddTaskRuleComponent,
    TaskRuleTimingComponent,
  ],
  imports: [CommonModule, OperationsRoutingModule, SharedModule],
  exports: [],
})
export class OperationsModule {}
